import { createSlice } from '@reduxjs/toolkit';

type IData = {
  id: string;
  request_id: string;
  status: string;
  created_by: string;
  created_at: string;
  db_id: string;
  content: null;
  reject_document_id: null;
  details: null;
  organization: string;
  status_content: string;
};

type RequestCommandState = {
  loading: boolean;
  data: IData[];
};

const initialState: RequestCommandState = {
  loading: false,
  data: [],
};

export const commandHistorySlice = createSlice({
  name: 'commandHistory',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setData: (state, action) => {
      // @ts-ignore
      state.data = action.payload;
    },
    // setInitialState: (state, action,)=>{
    //   state.data = initialState
    // }
  },
});

export default commandHistorySlice.reducer;
